<template>
  <div
    class="ranking-ots-parts"
    :class="[
      `ranking-ots-parts--${screenOrientationType}`,
      { 'ranking-ots-parts--running-low': otsValue < 20 },
      { 'ranking-ots-parts--enabled': otsEnabled },
      { 'ranking-ots-parts--disabled': otsDisabled },
    ]"
  >
    <svg
      class="ranking-ots-parts__gauge"
      preserveAspectRatio="none"
      width="100"
      height="8"
      viewBox="0 0 100 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <!-- マスク: ゲージ全体 -->
      <clipPath :id="`ranking-ots-parts__gauge__clip${id}`">
        <path
          opacity="0.3"
          d="M4.86133 0.5H88.7924C89.7657 0.5 90.7219 0.755698 91.5653 1.24149L97.2224 4.5H13.2914C12.3181 4.5 11.3619 4.2443 10.5185 3.75851L4.86133 0.5Z"
          fill="white"
        />
      </clipPath>

      <!-- マスク: ゲージ残量 -->
      <mask
        :id="`ranking-ots-parts__gauge__clip2${id}}`"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        width="85.36"
        height="4"
      >
        <rect :width="gaugeWidth" height="4" x="0" y="0" transform="skewX(63)" fill="white" />
      </mask>
      <!-- マスク: ゲージ残量 -->
      <clipPath :id="`telemetry-ots-parts__gauge__enabled-clip${id}}`">
        <path
          class="st0"
          d="M3.2,0.4h86.3c1,0,2,0.3,2.9,0.9l5.8,4.1H11.9c-1,0-2-0.3-2.9-0.9L3.2,0.4z"
        />
        <!--        <path fill="white" d="M0,0h86.3c1,0,2,0.3,2.9,0.9L94.9,5H8.7c-1,0-2-0.3-2.9-0.9L0,0z"/>-->
      </clipPath>
      <defs>
        <!-- OTS ON時 下反射アニメーショングラデーション -->
        <linearGradient
          :id="`gaugeReflectGradient${id}`"
          x1="0"
          y1="4"
          x2="170.72"
          y2="4"
          gradientUnits="userSpaceOnUse"
          spreadMethod="reflect"
        >
          <animate attributeName="x1" dur="2s" from="-100%" to="100%" repeatCount="indefinite" />
          <animate attributeName="x2" dur="2s" from="0%" to="200%" repeatCount="indefinite" />

          <stop offset="0" stop-color="#00FFBA" />
          <stop offset="0.25" stop-color="#00FFBA" stop-opacity="0.4" />
          <stop offset="0.50" stop-color="#00FFBA" />
          <stop offset="0.75" stop-color="#00FFBA" stop-opacity="0.4" />
          <stop offset="1" stop-color="#00FFBA" />
        </linearGradient>
      </defs>

      <path
        opacity="0.3"
        d="M4.86133 0.5H88.7924C89.7657 0.5 90.7219 0.755698 91.5653 1.24149L97.2224 4.5H13.2914C12.3181 4.5 11.3619 4.2443 10.5185 3.75851L4.86133 0.5Z"
        fill="white"
      />

      <!-- ゲージ下ライン -->
      <path
        :fill="fillColor"
        opacity="0.3"
        d="M99.3056 6.52778H12.22C11.0374 6.52778 9.87437 6.22576 8.84117 5.65035L1.38889 1.5H0L8.25478 6.35852C9.21557 6.92402 10.3101 7.22222 11.425 7.22222H100L99.3056 6.52778Z"
      />

      <!-- 残量ゲージ -->
      <g :clip-path="`url(#ranking-ots-parts__gauge__clip${id})`">
        <!--        :transform="`translate(4.86, 0)`"-->
        <g
          :mask="`url(#ranking-ots-parts__gauge__clip2${id})`"
          :transform="`translate(${gaugePositionX}, 0)`"
        >
          <rect
            v-if="!otsEnabled"
            width="85.36"
            height="4"
            x="0"
            y="0"
            :fill="fillColor"
            transform="skewX(63)"
            opacity="0.8"
          />
          <rect
            v-else
            class="ranking-ots-parts__gauge__enabled__animation"
            width="85.36"
            height="4"
            x="0"
            y="0"
            transform="skewX(63)"
            :fill="`url(#gaugeReflectGradient${id})`"
          />
        </g>
      </g>

      <g
        v-if="otsEnabled"
        :clip-path="`url(#telemetry-ots-parts__gauge__enabled-clip${id}})`"
        transform="translate(-1.5, -1)"
      >
        <g
          class="ranking-ots-parts__gauge__enabled__left-gradient"
          :transform="`translate(${gaugePositionX - 2}, .5)`"
        >
          <!-- ゲージ OTS ON時 左グラデ -->
          <path
            d="M5 1H17.7749C18.6145 1 19.44 1.21623 20.1717 1.62785L26.1667 5H13.3918C12.5522 5 11.7267 4.78377 10.9949 4.37215L5 1Z"
            :fill="`url(#enabledOtsGaugeLeftGradation${id})`"
          />
          <path
            d="M5 1H17.7749C18.6145 1 19.44 1.21623 20.1717 1.62785L26.1667 5H13.3918C12.5522 5 11.7267 4.78377 10.9949 4.37215L5 1Z"
            :fill="`url(#enabledOtsGaugeLeftGradation${id})`"
          />
          <path
            d="M5 1H17.7749C18.6145 1 19.44 1.21623 20.1717 1.62785L26.1667 5H13.3918C12.5522 5 11.7267 4.78377 10.9949 4.37215L5 1Z"
            :fill="`url(#enabledOtsGaugeLeftGradation${id})`"
          />
        </g>

        <g
          class="ranking-ots-parts__gauge__enabled__left-gradient"
          :transform="`translate(${gaugePositionX - 2.5}, 0)`"
        >
          <!-- ゲージ OTS ON時 下線 -->
          <path
            d="M4.82628 0.696474C4.58471 0.56748 4.31508 0.5 4.04122 0.5H3.20834L11.8308 5.29026C12.0784 5.42782 12.357 5.5 12.6402 5.5H98.125L97.7083 5.08333H13.2502C13.1133 5.08333 12.9785 5.04959 12.8577 4.9851L4.82628 0.696474Z"
            :fill="`url(#enabledOtsGaugeUnderLine${id})`"
          />
        </g>

        <defs>
          <linearGradient
            :id="`enabledOtsGaugeLeftGradation${id}`"
            x1="6.52778"
            y1="6.91667"
            x2="18.1389"
            y2="0.500001"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>

          <linearGradient
            :id="`enabledOtsGaugeUnderLine${id}`"
            x1="-9.77173"
            y1="5.5"
            x2="-9.76158"
            y2="6.54616"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="#98FFE6" stop-opacity="0.4" />
          </linearGradient>
        </defs>
      </g>
    </svg>

    <p v-if="otsDisabled" class="ranking-ots-parts__disabled-time">
      <svg
        class="ranking-ots-parts__disabled-time__icon"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.5 9C14.5 12.0376 12.0376 14.5 9 14.5C7.75165 14.5 6.60043 14.0841 5.67736 13.3833L13.3833 5.67736C14.0841 6.60043 14.5 7.75165 14.5 9ZM4.6167 12.3226L12.3226 4.6167C11.3996 3.9159 10.2484 3.5 9 3.5C5.96243 3.5 3.5 5.96243 3.5 9C3.5 10.2484 3.9159 11.3996 4.6167 12.3226ZM16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9Z"
          fill="#FFB800"
        />
      </svg>

      <span class="ranking-ots-parts__disabled-time__data">
        <span class="ranking-ots-parts__number">{{ otsDisabledTime }}</span>
        <sup class="ranking-ots-parts__unit"><span>s</span></sup>
      </span>
    </p>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

/**
 * レース動画再生画面 テレメトリー オーバーテイク残時間 値パーツのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryOtsParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    otsValue: {
      type: Number,
      default: 200,
    },
    /**
     * 固有ID
     */
    id: {
      type: Number,
      default: 0,
    },
    /**
     * オーバーテイクシステム有効フラグ
     */
    otsEnabled: {
      type: Boolean,
      default: false,
    },
    /**
     * オーバーテイクシステム無効残時間
     */
    otsDisabledTime: {
      type: Number,
      default: 0,
    },
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    carNoData: {
      type: Number,
      default: 0,
    },
    otsDatas: {
      type: Object,
      dafault: () => [],
    },
  },
  setup(props) {
    const { adjustPosition } = useTelemetrySectionUtil()

    // 位置指定を整数化
    adjustPosition('.ranking-ots-parts')

    // ゲージ横幅
    const gaugeSvgWidth = 85.36

    /**
     * gaugeWidth
     * ゲージの横幅を算出
     */
    const gaugeWidth = computed(() => (gaugeSvgWidth * props.otsValue) / 200)

    /**
     * gaugePositionX
     * ゲージのX位置を算出
     */
    // const gaugePositionX = computed(() => gaugeSvgWidth - (gaugeSvgWidth * props.otsValue) / 200 + 4.86)
    const gaugePositionX = computed(
      () => gaugeSvgWidth - (gaugeSvgWidth * props.otsValue) / 200 + 4.86,
    )

    /**
     * SVGカラー
     * 残秒数が一定以下時に赤へ変更
     */
    const fillColor = computed(() => (props.otsValue > 20 ? '#fff' : '#ff2e00'))

    /**
     * オーバーテイクシステム無効状態判定
     */
    const otsDisabled = computed(() => props.otsDisabledTime > 0)

    return {
      gaugeWidth,
      gaugePositionX,
      fillColor,
      otsDisabled,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
@keyframes countdownBlink {
  0%,
  100% {
    opacity: 0;
  }

  25%,
  75% {
    opacity: 1;
  }
}
@keyframes enabledLeftShadowBlink {
  0%,
  100% {
    opacity: 0.5;
  }

  25%,
  75% {
    opacity: 1;
  }
}
@keyframes enabledTransition {
  0% {
    transform: translateX(-75%) skewX(45deg);
  }

  100% {
    transform: translateX(-25%) skewX(45deg);
  }
}
@keyframes enabledReflectTransition {
  0% {
    transform: translateX(-75%) skewX(-45deg);
  }

  100% {
    transform: translateX(-25%) skewX(-45deg);
  }
}

.ranking-ots-parts {
  position: relative;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-end;
  justify-content: space-between;
  height: 0.867em;
  line-height: 1;
  color: #fff;

  &--running-low {
    color: $red-light;
  }

  &--disabled {
    .ranking-ots-parts__data,
    .ranking-ots-parts__gauge {
      opacity: 0.3;
    }
  }

  &__number {
    font-size: 1.5em;
    letter-spacing: 0.02em;
  }

  &__unit {
    display: inline-block;
    margin-left: 0.2em;
    font-size: 0.91667em;
    font-weight: 500;
    opacity: 0.5;

    span {
      display: inline-block;
      font-size: max(1em, 8px);
      transform: translateY(-4%);
    }
  }

  &__label {
    display: inline-block;
    padding: 0 0.333em 0 0;
    margin-right: 0.67em;
    letter-spacing: 0.08em;
    line-height: 1.1;
    background: transparent;
    color: rgba(255, 255, 255, 80%);
    transition: all ease 0.2s;

    span {
      font-size: max(1em, 8px);
      border-radius: 2px;
    }
  }

  &__gauge {
    overflow: visible;
    width: 100%;

    * {
      transition: width linear 1s;
    }

    &__enabled {
      &__left-shadow {
        animation: 0.5s linear enabledLeftShadowBlink infinite;
      }
    }
  }

  &__disabled-time {
    position: absolute;
    right: 0;
    top: 50%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-end;
    padding: 0 0.667em;
    font-size: 0.83334em;
    transform: translateY(-50%);

    &__data {
      animation: 1s ease-in-out countdownBlink infinite;
    }

    .ranking-ots-parts__unit {
      color: #ffb800;
      opacity: 1;
    }

    .ranking-ots-parts__number {
      display: inline-block;
      min-width: 1.8em;
      color: #ffb800;
      text-align: right;
    }

    &__icon {
      width: 1.5em;
      height: 1.5em;
      opacity: 0.5;
    }
  }

  @media screen and (max-width: 374px) {
    .ranking-ots-parts {
      &__gauge {
        height: 8px;
      }

      &__disabled-time {
        font-size: 10px;
        padding: 0 4px 0 0;

        .ranking-ots-parts__unit {
          color: #ffb800;
          opacity: 1;

          span {
            font-size: 8px;
          }
        }

        .ranking-ots-parts__number {
          display: inline-block;
          min-width: 1.6em;
          font-size: 10px;
        }

        &__icon {
          width: 12px;
          height: 12px;
        }
      }
    }
  }

  &--landscape-primary,
  &--landscape-secondary {
    justify-content: flex-end;

    .ranking-ots-parts {
      &__gauge {
        height: 8px;
      }

      &__disabled-time {
        font-size: 10px;
        padding: 0 4px 0 0;

        .ranking-ots-parts__unit {
          color: #ffb800;
          opacity: 1;

          span {
            font-size: 8px;
          }
        }

        .ranking-ots-parts__number {
          display: inline-block;
          min-width: 1.6em;
          font-size: 10px;
        }

        &__icon {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
}
</style>
